import { render } from "./indexBoxed.vue?vue&type=template&id=043666ee"
import script from "./indexBoxed.vue?vue&type=script&lang=js"
export * from "./indexBoxed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__